"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Button = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/action/Button"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ContentWrapper = _interopRequireDefault(require("./ContentWrapper"));
var _Carousel = _interopRequireDefault(require("./designsystem/Carousel"));
var _PhotoModal = _interopRequireDefault(require("./designsystem/PhotoModal"));
var _Section = _interopRequireDefault(require("./designsystem/Section"));
var _Tile = _interopRequireDefault(require("./designsystem/Tile"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
const PhotoSection = ({
  photos,
  onOpen,
  onClose,
  open
}) => {
  const {
    0: startIndex,
    1: setStartIndex
  } = (0, _react.useState)(0);
  const onModalClose = () => {
    onClose();
    setStartIndex(0);
  };
  if (!photos.length) {
    return null;
  }
  return __jsx(_Section.default, {
    id: "photos",
    className: "gt-xs"
  }, __jsx(_ContentWrapper.default, null, __jsx(_Carousel.default, {
    title: __jsx(_reactIntl.FormattedMessage, {
      id: "hpevRv",
      defaultMessage: [{
        "type": 0,
        "value": "Foto's"
      }]
    }),
    continuous: true
  }, photos.map(({
    jpegTile,
    webpTile
  }, imageIndex) => {
    if (!jpegTile || !webpTile) {
      return null;
    }
    return __jsx(Wrapper, {
      key: jpegTile?.src,
      onClick: () => {
        setStartIndex(imageIndex);
        onOpen();
      }
    }, __jsx(_Tile.default, {
      loading: "lazy",
      jpeg: jpegTile,
      webp: webpTile
    }));
  })), __jsx("div", null, __jsx(_Button.default, {
    onClick: onOpen,
    variant: "outline"
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "/Cg2AB",
    defaultMessage: [{
      "type": 0,
      "value": "Foto's bekijken"
    }]
  }))), __jsx(_PhotoModal.default, {
    startIndex: startIndex,
    open: open,
    onClose: onModalClose,
    imagesOrCategories: photos.map(({
      webpGallery,
      jpegGallery
    }) => ({
      jpeg: jpegGallery,
      webp: webpGallery
    }))
  })));
};
var _default = exports.default = PhotoSection;
const Wrapper = _styledComponents.default.div.withConfig({
  displayName: "PhotoSection__Wrapper",
  componentId: "sc-1hfmg6y-0"
})(["scroll-snap-align:start;cursor:pointer;& + &{margin-left:3.2rem;}&:last-child{margin-right:3.2rem;}"]);